import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-249f7161"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置 ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 批量交付 ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 获取最新数据 ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 交付超期 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 成本超额 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("填写备注 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("查看备注")
const _hoisted_9 = { class: "d-flex flex-wrap justify-content--around invoiceContent" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"45%"} }, null, -1))
const _hoisted_11 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-1" }, null, -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("确定 ")
const _hoisted_14 = {
  key: 0,
  style: {"color":"red"}
}

import {computed, getCurrentInstance, onActivated, onBeforeMount, reactive, ref} from 'vue'
import Api from '@/http/modules/index'
import tbMix from "@/global_mixin/tableMixin";
import {formatNumber, formatTime} from '@/utils/index'
import {useStore} from "vuex";
import {onMounted} from "@vue/runtime-core";


export default /*#__PURE__*/_defineComponent({
  props: {
  isPaid: {
    type: Boolean,//已支付页面，未支付页面
    required: true
  }
},
  setup(__props) {

const props = __props

let instance: any = getCurrentInstance()
const globalProperties = instance.appContext.config.globalProperties

const store = useStore()
const {
  //列表
  'POST/order/proceeding/list': fetchList,
  //订单成本
  'GET/rt/order/{no}/costs': orderCostsApi,
  'GET/isAdmin': isAdminApi,
  //添加或更新备注
  'POST/order/comment': addOrUpdateCommentApi,
  "GET/order/{id}/comment/list": orderCommentsApi,
  // 订单交付_获取最新数据
  'GET/order/delivery/query_latest_data': query_latest_dataApi,
  //pm交付
  'POST/order/pm_batch_delivery': pmBatchDeliveryApi,
  //需要成本控制的订单条数
  "GET/order/cost_control_count": costControlCountApi
} = Api

const {
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)
let selectionRows = ref<any[]>([])
let parmasObj = reactive({
  customerUsername: '',
  no: '',
  name: '',
  owner: "",
  po: '',
  pm: '',
  sortColumn: "days",
  sortDirection: "DESC",
  isPaid: props.isPaid,
  expireEventOrder:false,
  costEventOrder:false,
})
let addOrUpdateCommentParamsObj = reactive<{ id: number | null, orderId: number, event: string, msg: string,sourceType:string}>({
  id: null,
  orderId: 0,
  event: '',
  msg: '',
  sourceType:'PROJECT_DELIVERY'
})

let orderCostDialogInfo = reactive({
  isShow: false,
  loading: false,
  error: '',
  data: []
})

let orderCommentsDialogInfo = reactive<{ isShow: boolean, loading: boolean, error: string, data: any, order: any }>({
  isShow: false,
  loading: false,
  error: '',
  data: [],
  order: undefined
});
let addOrUpdateCommentDialogInfo = reactive<{ isShow: boolean, order: object | null, loading: boolean }>({
  isShow: false,
  order: null,
  loading: false
})

const searchEle = ref()
const addOrUpdateForm = ref()
const isAdmin = ref<boolean>(false)

onBeforeMount(() => {
  isAdminApi().then((rep: boolean) => {
    isAdmin.value = rep
  })
})
const toast = ref<Boolean>(false)
onMounted(() => {
  if (props.isPaid) {
    return
  }
  costControlCountApi().then((r: any) => {
    if (toast.value) {
      return
    }
    toast.value = true;
    if (r.count > 0) {
      globalProperties.$message({
        type: 'warning',
        message: "您有" + r.count + "条订单需要备注",
        duration: 10000,
        showClose: true,
      })
    }
  })
})


const searchOrders = () => {
  parmasObj.costEventOrder=false
  parmasObj.expireEventOrder=false
  fetchData(parmasObj)
}
searchOrders()
const defaultSort = computed(() => {
  return {
    prop: parmasObj.sortColumn, order: parmasObj.sortDirection == 'ASC' ? "ascending" : 'descending'
  }
})
const onSortChange = ({column, prop, order}: any) => {

  parmasObj.sortColumn = prop
  if (order) {
    parmasObj.sortDirection = order == "ascending" ? "ASC" : "DESC"
  } else {
    parmasObj.sortDirection = "NULL"
  }
  MI_params.sortColumn = parmasObj.sortColumn;
  MI_params.sortDirection = parmasObj.sortDirection
  // console.log("mi params",MI_params,parmasObj)
  MI_pageChange(1)

}
const calRowClass = ({row, rowIndex}: any) => {
  if (row.events.length > 0) {
    return " problem-order "
  }
  return ""
}

const onClickCell = (row: any, column: any, cell: any, event: any) => {
  if (column.property == "cost") {
    // //点击成本，展示成本单列表
    orderCostDialogInfo.loading = true
    orderCostDialogInfo.error = ''
    orderCostDialogInfo.data = []
    orderCostDialogInfo.isShow = true
    orderCostsApi({no: row.no}).then((r: any) => {
      orderCostDialogInfo.loading = false
      orderCostDialogInfo.data = r
    }).catch((e: any) => {
      orderCostDialogInfo.loading = false
      orderCostDialogInfo.error = "加载失败，请关闭重试"
    })
  }
}
const checkSelect = (row: any, index: number) => {

  return isPMOrLeader(row);
}


const showComment = (row: any) => {
  orderCommentsDialogInfo.loading = true
  orderCommentsDialogInfo.error = ''
  orderCommentsDialogInfo.data = []
  orderCommentsDialogInfo.isShow = true
  orderCommentsDialogInfo.order = row
  orderCommentsApi({id: row.id}).then((r: any) => {
    orderCommentsDialogInfo.loading = false
    orderCommentsDialogInfo.data = r
  }).catch((e: any) => {
    orderCommentsDialogInfo.loading = false
    orderCommentsDialogInfo.error = "加载失败，请关闭重试"
  })
}
const showAddOrUpdateCommentDialog = async (row: any, comment: any) => {
  addOrUpdateCommentParamsObj.id = comment ? comment.id : null
  addOrUpdateCommentParamsObj.event = comment ? comment.event : ''
  addOrUpdateCommentParamsObj.orderId = row.id
  addOrUpdateCommentParamsObj.msg = comment ? comment.msg : ''
  addOrUpdateCommentDialogInfo.order = row
  orderCommentsDialogInfo.data =await orderCommentsApi({id: row.id})
  addOrUpdateCommentDialogInfo.isShow = true
  setTimeout(() => {
    addOrUpdateForm.value.clearValidate();
  }, 50)
}

const formatType = (row: Object, column: any, cellValue: string, index: number) => {
  switch (cellValue) {
    case 'manual':
      return '手动'
    case 'mars':
      return 'mars'
    case 'co2':
      return 'co2'
    case 'manual_advance':
      return '预付款'
    default:
      return cellValue
  }
}


const isPMOrLeader = (row: any) => {
  const userName = store.getters.userName.toLowerCase();
  const itemPm = row.pm.toLowerCase();
  if (userName.indexOf("(") >= 0) {
    return isAdmin.value ||
        (itemPm == userName) ||
        ((row.leaderId == store.getters.userId)) ||
        (itemPm == userName.substr(0, userName.indexOf("("))) ||
        (itemPm == userName.substr(userName.indexOf("(") + 1).replace(")", ""))
  }
  return isAdmin.value || (itemPm == userName) || ((row.leaderId == store.getters.userId))
}
const needShowAddCommentBtn = (row: any) => {
  if (isPMOrLeader(row)) {
    return row.events.length > 0
  }
  return false
}

const addOrUpdateComment = () => {
  addOrUpdateForm.value.validate((valid: boolean) => {
    if (valid) {
      addOrUpdateCommentDialogInfo.loading = true
      addOrUpdateCommentApi(addOrUpdateCommentParamsObj).then((r: any) => {
        addOrUpdateCommentDialogInfo.loading = false
        const filtered = MI_tableData.value.filter((i: any) => i.id == addOrUpdateCommentParamsObj.orderId);
        if (filtered.length > 0) {
          filtered[0].events = filtered[0].events.filter((i: string) => i != addOrUpdateCommentParamsObj.event);
        }
        if (orderCommentsDialogInfo.order && orderCommentsDialogInfo.order.id && (orderCommentsDialogInfo.order.id == addOrUpdateCommentParamsObj.orderId)) {
          showComment(orderCommentsDialogInfo.order)
        }
        globalProperties.$message.success(addOrUpdateCommentParamsObj.id ? '添加备注成功' : '修改备注成功')
        addOrUpdateCommentDialogInfo.isShow = false
      }).catch((e: any) => {
        addOrUpdateCommentDialogInfo.loading = false
        globalProperties.$message.error((addOrUpdateCommentParamsObj.id ? '添加备注失败' : '修改备注失败') + e)
      })
    } else {
      return false
    }
  })
}
const fetchExpireEventOrder=()=>{
  searchEle.value.resetFields();
  parmasObj.expireEventOrder=true
  parmasObj.costEventOrder=false
  fetchData(parmasObj)
}
const fetchCostEventOrder=()=>{
  searchEle.value.resetFields();
  parmasObj.expireEventOrder=false
  parmasObj.costEventOrder=true
  fetchData(parmasObj)
}

//批量交付
const delivering = ref<boolean>(false)
const batchDelivery = () => {
  if (delivering.value) {
    return
  }
  if (selectionRows.value.length < 1) {
    globalProperties.$message.warning("请选择需要交付的订单")
    return
  }
  // 检查成本是大于金额的40%
  const arr = [];
  for (let i = 0; i < selectionRows.value.length; i++) {
    let item = selectionRows.value[i]
    if (item.cost < item.amount * 0.4) {
      arr.push(item.no);
    }
  }
  let msg;
  if (arr.length > 0) {
    msg = "您选中的订单中有" + arr.length + "个订单(" + arr.join(",") + ")的成本小于订单金额的40%，是否存在成本尚未计入，或是在其他订单里的情况。确定要交付吗？";
  } else {
    msg = "您确定要交付选中的订单吗";
  }
  globalProperties.$confirm(msg, "提示", {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    delivering.value = true
    let ids = selectionRows.value.map(i => i.id)
    pmBatchDeliveryApi({ids}).then(() => {
      delivering.value = false
      MI_pageChange(page.value)
      globalProperties.$message.success("批量交付成功")
    }).catch((e: any) => {
      delivering.value = false
      globalProperties.$message.error("批量交付失败：" + e)
    })
  }).catch(() => {
    //ignore
  })


}

// 获取最新数据
const btnLoading = ref<boolean>(false)
const getLastDataHandle = () => {
  btnLoading.value = true
  globalProperties.$message.warning('正在获取中')
  query_latest_dataApi({}, {timeout: 0}).finally(() => {
    btnLoading.value = false
  })
}



return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, { class: "mb-10" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, {
          title: "订单交付列表-搜索",
          name: "1"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              class: "searchContent searchBg",
              model: _unref(parmasObj),
              "label-width": "90px",
              inline: true,
              ref_key: "searchEle",
              ref: searchEle,
              "label-position": "right"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "客户名称:",
                  prop: "customerUsername"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      clearable: "",
                      modelValue: _unref(parmasObj).customerUsername,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(parmasObj).customerUsername) = $event)),
                      placeholder: "请输入客户名称",
                      class: "form-input",
                      maxlength: "100"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "订单号:",
                  prop: "no"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      clearable: "",
                      modelValue: _unref(parmasObj).no,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(parmasObj).no) = $event)),
                      placeholder: "请输入订单号",
                      class: "form-input",
                      maxlength: "100"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "订单名称:",
                  prop: "name"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      clearable: "",
                      modelValue: _unref(parmasObj).name,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(parmasObj).name) = $event)),
                      placeholder: "请输入订单名称",
                      class: "form-input",
                      maxlength: "100"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "客户经理:",
                  prop: "owner"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      clearable: "",
                      modelValue: _unref(parmasObj).owner,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(parmasObj).owner) = $event)),
                      placeholder: "请输入客户经理",
                      class: "form-input",
                      maxlength: "100"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "PO号:",
                  prop: "po"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      clearable: "",
                      modelValue: _unref(parmasObj).po,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(parmasObj).po) = $event)),
                      placeholder: "请输入PO号",
                      class: "form-input",
                      maxlength: "100"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "PM:",
                  prop: "pm"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      clearable: "",
                      modelValue: _unref(parmasObj).pm,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(parmasObj).pm) = $event)),
                      placeholder: "请输入PM",
                      class: "form-input",
                      maxlength: "100"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (searchOrders()))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => {searchEle.value.resetFields();})
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (!_unref(parmasObj).isPaid)
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          disabled: _unref(MI_identify)||delivering.value,
          loading: delivering.value,
          onClick: batchDelivery
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["disabled", "loading"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_button, {
      onClick: _cache[8] || (_cache[8] = ($event: any) => (getLastDataHandle())),
      loading: btnLoading.value
    }, {
      default: _withCtx(() => [
        _hoisted_4,
        _createVNode(_component_el_tooltip, {
          effect: "dark",
          content: "下方列表默认显示PM今天之前的订单，点击按钮可获取最新数据",
          placement: "bottom"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_QuestionFilled)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["loading"]),
    (!_unref(parmasObj).isPaid)
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "primary",
          disabled: _unref(MI_identify)||delivering.value,
          loading: delivering.value,
          onClick: fetchExpireEventOrder
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["disabled", "loading"]))
      : _createCommentVNode("", true),
    (!_unref(parmasObj).isPaid)
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 2,
          type: "primary",
          disabled: _unref(MI_identify)||delivering.value,
          loading: delivering.value,
          onClick: fetchCostEventOrder
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["disabled", "loading"]))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "projectTbEle",
      border: "",
      class: "mt-10",
      data: _unref(MI_tableData),
      "row-key": "id",
      "default-sort": _unref(defaultSort),
      onSortChange: onSortChange,
      "row-class-name": calRowClass,
      "max-height": _unref(MI_height) - 100 + 'px',
      onCellClick: onClickCell,
      onSelectionChange: _cache[9] || (_cache[9] = (rows) => _isRef(selectionRows) //@ts-ignore
 ? selectionRows.value = rows : selectionRows = rows)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          width: "50",
          type: "selection",
          selectable: checkSelect,
          fixed: "",
          "reserve-selection": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "订单号",
          prop: "no",
          "show-overflow-tooltip": "",
          width: "120",
          sortable: "custom",
          fixed: ""
        }),
        _createVNode(_component_el_table_column, {
          label: "订单名",
          prop: "name",
          "show-overflow-tooltip": "",
          width: "100",
          sortable: "custom"
        }),
        _createVNode(_component_el_table_column, {
          label: "承接时间",
          prop: "startTime",
          "show-overflow-tooltip": "",
          width: "120",
          sortable: "custom"
        }),
        _createVNode(_component_el_table_column, {
          label: "首次产生成本",
          prop: "costDateCreated",
          "show-overflow-tooltip": "",
          width: "140",
          sortable: "custom"
        }),
        _createVNode(_component_el_table_column, {
          label: "超期（天）",
          prop: "days",
          "show-overflow-tooltip": "",
          width: "120",
          sortable: "custom"
        }),
        _createVNode(_component_el_table_column, {
          label: "客户经理",
          prop: "owner",
          "show-overflow-tooltip": "",
          width: "120",
          sortable: "custom"
        }),
        _createVNode(_component_el_table_column, {
          label: "PM",
          prop: "pm",
          "show-overflow-tooltip": "",
          width: "100",
          sortable: "custom"
        }),
        _createVNode(_component_el_table_column, {
          label: "AM",
          prop: "am",
          "show-overflow-tooltip": "",
          width: "100",
          sortable: "custom"
        }),
        _createVNode(_component_el_table_column, {
          label: "USD金额",
          prop: "baseCurrencyMoney",
          "show-overflow-tooltip": "",
          width: "120",
          sortable: "custom"
        }),
        _createVNode(_component_el_table_column, {
          label: "原币别",
          prop: "currency",
          "show-overflow-tooltip": "",
          width: "100",
          sortable: "custom"
        }),
        _createVNode(_component_el_table_column, {
          label: "原金额",
          prop: "amount",
          "show-overflow-tooltip": "",
          width: "100",
          sortable: "custom"
        }),
        _createVNode(_component_el_table_column, {
          "class-name": "cursor-pointer",
          label: "成本",
          prop: "cost",
          "show-overflow-tooltip": "",
          width: "100",
          sortable: "custom"
        }),
        _createVNode(_component_el_table_column, {
          label: "状态",
          prop: "status",
          "show-overflow-tooltip": "",
          width: "100",
          sortable: "custom"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "160",
          fixed: "right"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_space, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_link, {
                  disabled: !needShowAddCommentBtn(row),
                  onClick: ($event: any) => (showAddOrUpdateCommentDialog(row,null))
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 2
                }, 1032, ["disabled", "onClick"]),
                _createVNode(_component_el_link, {
                  disabled: !isPMOrLeader(row)||row.handledEventCount<1,
                  onClick: ($event: any) => (showComment(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 2
                }, 1032, ["disabled", "onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "default-sort", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      disabled: _unref(MI_identify),
      background: "",
      small: "",
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[10] || (_cache[10] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[11] || (_cache[11] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      class: "mt-10",
      "page-sizes": [10, 30, 50, 100, 300, 1000],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["disabled", "total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      title: "订单成本",
      modelValue: _unref(orderCostDialogInfo).isShow,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(orderCostDialogInfo).isShow) = $event)),
      width: "1260",
      center: "",
      draggable: ""
    }, {
      footer: _withCtx(() => [
        (_unref(orderCostDialogInfo).error.length>0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(orderCostDialogInfo).error), 1))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            border: "",
            data: _unref(orderCostDialogInfo).data,
            "row-key": "id"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                label: "co订单号",
                prop: "coOrderId",
                "show-overflow-tooltip": "",
                width: "120",
                fixed: ""
              }),
              _createVNode(_component_el_table_column, {
                label: "ID",
                prop: "id",
                "show-overflow-tooltip": "",
                width: "100"
              }),
              _createVNode(_component_el_table_column, {
                label: "译员ID",
                prop: "resourceId",
                "show-overflow-tooltip": "",
                width: "100"
              }),
              _createVNode(_component_el_table_column, {
                label: "是否内部译员",
                prop: "isCcjkUser",
                formatter: (row) => row.isCcjkUser === true ? '是' : '否'
              }, null, 8, ["formatter"]),
              _createVNode(_component_el_table_column, {
                label: "任务Id",
                prop: "taskId"
              }),
              _createVNode(_component_el_table_column, {
                label: "是否不计算",
                prop: "isNoCalculated",
                formatter: (row) => row.isNoCalculated ? '不计算': '计算'
              }, null, 8, ["formatter"]),
              _createVNode(_component_el_table_column, {
                label: "译员名字",
                prop: "fullName",
                width: "100",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "译员币种",
                prop: "resourceCurrency",
                width: "100",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "类型",
                prop: "type",
                width: "120",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "借方",
                prop: "debit",
                formatter: _unref(formatNumber)
              }, null, 8, ["formatter"]),
              _createVNode(_component_el_table_column, {
                label: "贷方",
                prop: "credit",
                formatter: _unref(formatNumber)
              }, null, 8, ["formatter"]),
              _createVNode(_component_el_table_column, {
                label: "汇率",
                prop: "rate",
                width: "80"
              }),
              _createVNode(_component_el_table_column, {
                label: "本位币",
                prop: "basicCurrency",
                width: "120"
              }),
              _createVNode(_component_el_table_column, {
                label: "余额时间",
                prop: "paymentTime",
                width: "120",
                formatter: _unref(formatTime),
                "show-overflow-tooltip": ""
              }, null, 8, ["formatter"]),
              _createVNode(_component_el_table_column, {
                label: "创建时间",
                prop: "dateCreated",
                width: "120",
                formatter: _unref(formatTime),
                "show-overflow-tooltip": ""
              }, null, 8, ["formatter"]),
              _createVNode(_component_el_table_column, {
                label: "状态",
                prop: "status",
                width: "100"
              }),
              _createVNode(_component_el_table_column, {
                label: "公司",
                prop: "company",
                width: "100",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "数据来源",
                prop: "dataSourceType",
                width: "100",
                formatter: formatType
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, _unref(orderCostDialogInfo).loading]
          ]),
          _hoisted_10
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: _unref(addOrUpdateCommentParamsObj).id?'修改备注':'添加备注',
      modelValue: _unref(addOrUpdateCommentDialogInfo).isShow,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(addOrUpdateCommentDialogInfo).isShow) = $event)),
      width: "900",
      center: "",
      draggable: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_form, {
            class: "addCommentDialog",
            ref_key: "addOrUpdateForm",
            ref: addOrUpdateForm,
            model: _unref(addOrUpdateCommentParamsObj),
            "label-position": "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "备注事件",
                prop: "event",
                required: "",
                rules: [{required:true,message:'请选择备注事件'}]
              }, {
                default: _withCtx(() => [
                  (_unref(addOrUpdateCommentParamsObj).id)
                    ? (_openBlock(), _createBlock(_component_el_select, {
                        key: 0,
                        modelValue: _unref(addOrUpdateCommentParamsObj).event,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(addOrUpdateCommentParamsObj).event) = $event)),
                        placeholder: "请选择备注事件"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: _unref(addOrUpdateCommentParamsObj).event,
                            value: _unref(addOrUpdateCommentParamsObj).event
                          }, null, 8, ["label", "value"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]))
                    : (_openBlock(), _createBlock(_component_el_select, {
                        key: 1,
                        modelValue: _unref(addOrUpdateCommentParamsObj).event,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(addOrUpdateCommentParamsObj).event) = $event)),
                        placeholder: "请选择备注事件"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(addOrUpdateCommentDialogInfo).order.events, (event, index) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: event,
                              label: event,
                              value: event
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"]))
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "备注内容:",
                prop: "msg",
                required: "",
                rules: [{required:true,message:'请输入备注内容'}]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    clearable: "",
                    modelValue: _unref(addOrUpdateCommentParamsObj).msg,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(addOrUpdateCommentParamsObj).msg) = $event)),
                    type: "textarea",
                    rows: 3,
                    placeholder: "请输入备注类容"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _hoisted_12,
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (addOrUpdateComment())),
                    disabled: _unref(addOrUpdateCommentDialogInfo).loading,
                    loading: _unref(addOrUpdateCommentDialogInfo).loading
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  }, 8, ["disabled", "loading"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]),
          _createVNode(_component_el_table, {
            data: _unref(orderCommentsDialogInfo).data,
            style: {"width":"100%","margin-top":"-12px"},
            "empty-text": "暂无备注",
            border: "",
            "max-height": 400
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "event",
                label: "事件",
                width: "200",
                "show-overflow-tooltip": ""
              }, {
                default: _withCtx(({row}) => [
                  _createTextVNode(_toDisplayString(`${row.sourceType=='ORDER_DELIVERY'?'[订单交付]':'项目交付'}${row.event}`), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "createdAt",
                label: "填写时间",
                width: "180",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                prop: "commenter",
                label: "填写人",
                width: "160",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                prop: "msg",
                label: "备注",
                "show-overflow-tooltip": ""
              })
            ]),
            _: 1
          }, 8, ["data"])
        ])
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "订单备注",
      class: "order-comment-dialog",
      modelValue: _unref(orderCommentsDialogInfo).isShow,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(orderCommentsDialogInfo).isShow) = $event)),
      width: "900",
      center: "",
      draggable: ""
    }, {
      footer: _withCtx(() => [
        (_unref(orderCommentsDialogInfo).error.length>0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref(orderCommentsDialogInfo).error), 1))
          : _createCommentVNode("", true)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: _unref(orderCommentsDialogInfo).data,
          style: {"width":"100%"},
          "empty-text": "暂无备注",
          border: "",
          "max-height": 400
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "event",
              label: "事件",
              width: "200",
              "show-overflow-tooltip": ""
            }, {
              default: _withCtx(({row}) => [
                _createTextVNode(_toDisplayString(`${row.sourceType=='ORDER_DELIVERY'?'[订单交付]':'项目交付'}${row.event}`), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "createdAt",
              label: "填写时间",
              width: "180",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "commenter",
              label: "填写人",
              width: "160",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "msg",
              label: "备注",
              "show-overflow-tooltip": ""
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})